import { combineReducers } from 'redux';
import { ADD_TIMELINE, SET_SELECTED_STEP } from './types';

const timeline = (state, action) => {
  switch (action.type) {
    case ADD_TIMELINE:
      return {
        id: action.payload.id,
        selectedStep: action.payload.selectedStep || 1,
        nodes: action.payload.nodes
      };
    case SET_SELECTED_STEP:
      return {
        id: action.payload.id,
        selectedStep: action.payload.selectedStep,
        nodes: state.nodes
      };
    default:
      return state;
  }
};

const byId = (state = {}, action) => {
  switch (action.type) {
    case ADD_TIMELINE:
    case SET_SELECTED_STEP:
      return {
        ...state,
        [action.payload.id]: timeline(state[action.payload.id], action)
      };
    default:
      return state;
  }
};

const allIds = (state = [], action) => {
  switch (action.type) {
    case ADD_TIMELINE:
      return [...state, action.payload.id];
    default:
      return state;
  }
};

export const getAllTimelines = state => state.allIds.map(id => state.byId[id]);
export const getTimeline = (state, id) => state.byId[id];

const reducer = combineReducers({
  byId,
  allIds
});

export { reducer as timelineReducer };



// WEBPACK FOOTER //
// ./src/store/Timeline/reducer.js